<style lang="less" scoped>
.childhritem-contain {
  .headcount-contain {
      border-left: 1px solid rgba(0,0,0,.12);
  }
  .stat-info-child {
    box-shadow: none!important;
    border-radius: 0;
    // border-left: 1px solid rgba(0,0,0,.12);
    /deep/.v-list-item--two-line {
      min-height: 0 !important;
    }
    /deep/.v-card__text {
      padding-top: 0px;
      padding-bottom: 0px;
    }
    /deep/ .col-3 {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }
  .list-contain {
    /deep/.v-list-item__title {
       text-overflow:inherit;
       white-space: normal;
    }
        /deep/.v-list-item__subtitle {
       text-overflow:inherit;
       white-space: normal;
    }
}
}
</style>
<template>
  <div class="childhritem-contain">
    <v-list class="list-contain">
      <v-row>
        <v-col cols="5">
          <v-row>
            <v-col 
              cols="6"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ detail.team_name }}</v-list-item-title>
                  <v-list-item-subtitle>执行部门</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col 
              cols="6"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ formattingNumber(detail.future_expense,2) }}</v-list-item-title>
                  <v-list-item-subtitle>预计正式员工一年薪资支出金额</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col 
              cols="12"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ detail.remark }}</v-list-item-title>
                  <v-list-item-subtitle>备注</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col 
              cols="12"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <FileList :bfiles="detail.bfiles" />
                    <span v-if="!detail||!detail.bfiles || detail.bfiles.length===0">-</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>附件</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="7">
          <div class="headcount-contain">
            <v-row>
              <v-col
                v-for="(head,index) in detail.headcounts"
                :key="index"
                cols="12"
              >
                <v-card class="stat-info-child">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span style="font-weight:bold">HC条目-{{ index+1 }}</span>
                      </v-list-item-title>
                      <v-row>
                        <v-col 
                          cols="4"
                        >
                          <v-list-item-title>
                            {{ (customer_types_hash[head.headcount_type]||{}).label }}
                          </v-list-item-title>
                          <v-list-item-subtitle>申请HC类型</v-list-item-subtitle>
                        </v-col>
                        <v-col 
                          cols="4"
                        >
                          <v-list-item-title>
                            {{ head.headcount_total }}
                          </v-list-item-title>
                          <v-list-item-subtitle>申请HC个数</v-list-item-subtitle>
                        </v-col>
                        <v-col 
                          cols="4"
                        >
                          <v-list-item-title>
                            {{ head.sequence_name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>申请序列</v-list-item-subtitle>
                        </v-col>
                        <v-col 
                          cols="12"
                        >
                          <DaynamicTable 
                            :table-data="head.items"
                          />
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-list>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import FileList from './FileList'
  import { formattingNumber } from '../../../../libs/util'
  import DaynamicTable from './DaynamicTable'
  export default {
    components: {
      FileList,
      DaynamicTable
    },
    props: {
      detail: {
        type: Object
      }
    },
    computed: {
      ...mapGetters('async', {
        customer_types_hash: 'customer_types_hash',
      }),
    },
    methods: {
      formattingNumber:formattingNumber
    }
  }
</script>
